import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { CreateBoardList } from './boardList';

export function Qna(routeProps: RouteComponentProps) {
  return (
    <div className="content">
      {CreateBoardList(
        routeProps,
        {
          title: '질의응답',
          subTitle:
            '도서출판 구민사에 궁금하신 점이나 제안사항을 적어주세요. 빠른 답변으로 보답하겠습니다.',
          buttonText: '글쓰기',
          visableButton: true,
          ctgy: 'qna',
          replieButton: true,
          viewUrl: '/board/boardView',
        },
        // 글쓰기 이동
        () => {
          const query = {
            title: '질의응답',
            subTitle:
              '도서출판 구민사에 궁금하신 점이나 제안사항을 적어주세요. 빠른 답변으로 보답하겠습니다.',
            ctgy: 'qna',
          };
          routeProps.history.push({
            pathname: '/board/boardWriter',
            search: `?${new URLSearchParams(query).toString()}`,
          });
        },
        false
      )}
    </div>
  );
}
